import {Entity} from '@s-ui/domain'

/**
 * @export
 * @class UserEntity
 * @extends {Entity}
 */
export default class UserEntity extends Entity {
  /**
   * @constructor
   * @param {String} lastName
   * @param {String} name
   * @param {String} email
   * @param {String} phone
   * @param {Number} userId
   * @param {String} avatar
   * @param {Bool} hidePhone
   * @param {Bool} isEmailConfirmed
   * @param {String|Number} contractId
   * @param {String} zipCode
   * @param {Bool} active
   * @param {String} creationDate
   * @param {String} origin
   * @param {String} phone
   * @param {String} province
   * @param {String} provinceId
   * @param {String} token
   * @param {Bool} verified
   */

  getEmail() {
    return this._email
  }

  getId() {
    return this._userId
  }

  getLastName() {
    return this._lastName
  }

  getName() {
    return this._name
  }

  getPhone() {
    return this._phone
  }

  getProvinceId() {
    return this._provinceId
  }

  getToken() {
    return this._token
  }

  getZipCode() {
    return this._zipCode
  }
}
